import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import useGlobalState from '../GlobalStateContext';

import { OptionalRolesOrPermissions } from 'crm/helpers/Permissions';

type Props = {
    url: string;
    title: string | ReactElement;
    target?: string;
    className?: string;
} & OptionalRolesOrPermissions;

export default function ActionButton({
    url,
    title,
    roles = [],
    permissions = [],
    target = '',
    className = '',
}: Readonly<Props>) {
    const { loggedAdmin } = useGlobalState();

    return loggedAdmin.hasAccess(roles, permissions) ? (
        <Link target={target} className={`btn btn-primary btn-sm mr-1 ${className}`} to={url}>
            {title}
        </Link>
    ) : null;
}
